// Contact.jsx (used inside Home page)
import React from "react";
import {
  Container,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./Style.css";
// import { NavLink } from "react-router-dom";
import ContactImg from '../assets/BeachTour.jpeg';

function Contact() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/contact");
  };

  return (
    <Container
      maxWidth={false}
      disableGutters
      className="contact-container"
      id="Contact"
    >
      <Card className="contact-card">
        <CardContent>
          <Grid container spacing={4} alignItems="center">
            {/* Left Side - Image */}
            <Grid item xs={12} md={6}>
              <img
                src={ContactImg}
                alt="Contact"
                className="contact-image"
              />
            </Grid>

            {/* Right Side - Title + Button */}
            <Grid item xs={12} md={6}>
              <Typography variant="h4" className="contact-heading">
                Contact Us
              </Typography>
              <Typography variant="body1" className="contact-description">
                <br />
                <b>
                  Have any questions or need help planning your next adventure?
                </b>
                <br />
                Our team is ready to guide you. Reach out today.
                <br /><br/>
              </Typography>

              <Button
                variant="contained"
                className="contact-button"
                onClick={() => navigate("/contact-us")}
              >
                Contact Us
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
}

export default Contact;
